__turbopack_context__.v({
  "container": "SingleColumnLayoutWithOutHeaderFooter-module__NXkrBq__container",
  "logoContainer": "SingleColumnLayoutWithOutHeaderFooter-module__NXkrBq__logoContainer",
  "logoHeader": "SingleColumnLayoutWithOutHeaderFooter-module__NXkrBq__logoHeader",
});
